import { ExtensionApiFactory } from '~cdw-ae/common/frontend/browser-extension-api';

import { GBMessages } from './message-handler.interfaces';

import { environment } from '../../../environments/environment';
import { CheckInEffects } from '../check-in/check-in.state';
import { RootState, rootStore } from '../extension-store/extension.store';
import UtilsSerice from '../utils/utils.service';
import VersionUpdateService from '../version-update/version-update.service';

const MessageHandlerService = {
  init: async () => {
    const extensionApi = ExtensionApiFactory();
    UtilsSerice.debugLog('MessageHandlerService.init');

    extensionApi.addMessageListener(
      GBMessages.GET_EXTENSION_STATE,
      async (): Promise<RootState> => rootStore.getState()
    );

    extensionApi.addMessageListener(GBMessages.OPEN_HELP, async (): Promise<void> => {
      await VersionUpdateService.openRemoteHelp();
    });

    extensionApi.addMessageListener(GBMessages.OPEN_DEVICE_INFO, async (): Promise<void> => {
      const state = rootStore.getState();
      const url = UtilsSerice.appendUrlArguments(`${environment.apiServer}/support`, {
        method: 'deviceInfo',
        jwtToken: state.userProfile.userProfile.userJWT ?? 'NOT_SET',
        c: state.deviceDetails.details.id,
        d: state.userProfile.userProfile.domain,
        u: state.userProfile.userProfile.id,
        e: state.userProfile.userProfile.email,
        i: extensionApi.getExtensionId(),
      });

      await extensionApi.createTab({ url });
    });

    extensionApi.addMessageListener(GBMessages.CLEAR_CACHE, async (): Promise<{ success: boolean }> => {
      try {
        await extensionApi.clearStorage();
        return { success: true };
      } catch (error) {
        return { success: false };
      }
    });

    extensionApi.addMessageListener(GBMessages.RELOAD_EXTENSION, async (): Promise<void> => {
      await extensionApi.reloadExtension();
    });

    extensionApi.addMessageListener(GBMessages.RESYNC_EXTENSION, async (): Promise<{ success: boolean }> => {
      try {
        await rootStore.dispatch(CheckInEffects.checkIn());
        return { success: true };
      } catch (error) {
        return { success: false };
      }
    });

    extensionApi.addMessageListener(GBMessages.CHECK_VERSION, async (): Promise<{ success: boolean }> => {
      try {
        await VersionUpdateService.init();
        return { success: true };
      } catch (error) {
        return { success: false };
      }
    });

    extensionApi.addMessageListener(GBMessages.FIX_VERSION, async (): Promise<{ success: boolean }> => {
      try {
        await extensionApi.createTab({ url: 'chrome://os-settings/help' });
        VersionUpdateService.showFixVersionNotification();
        return { success: true };
      } catch (error) {
        return { success: false };
      }
    });

    extensionApi.addMessageListener(GBMessages.OPEN_FAQ, async (): Promise<void> => {
      await extensionApi.createTab({ url: environment.publicUrls.faqHelp });
    });
  },
};

export default MessageHandlerService;
